
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/list",
      function () {
        return require("private-next-pages/event/list.tsx");
      }
    ]);
  